import React from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import FormGrid from "./FormGrid";
import FormGroup from "./FormGroup";

const SignatureSection = ({
  name = "",
  date = "",
  acknowledge = false,
  legal = true,
  onNameChange,
  onDateChange,
  onAcknowledge,
}) => (
  <div className="signature-section">
    <p className="signature-disclaimer">
      {legal
        ? "I HAVE CAREFULLY READ AND FULLY UNDERSTAND ALL PROVISIONS OF THIS RELEASE, AND FREELY, VOLUNTARILY AND KNOWINGLY ASSUME THE RISK AND WAIVE MY RIGHTS CONCERNING LIABILITY AS DESCRIBED ABOVE. BY SIGNING BELOW, YOU CONFIRM THAT YOU HAVE READ AND AGREE TO THESE TERMS."
        : "Electronic signature indicates that I have read and consent to the details of this agreement."}
    </p>
    <div className="signature-acknowledge">
      <label className="custom-checkbox">
        <input
          type="checkbox"
          checked={acknowledge}
          onChange={(e) => onAcknowledge && onAcknowledge(e.target.checked)}
        />
        <span>Yes, I acknowledge and accept.</span>
      </label>
    </div>
    <FormGrid cols={2}>
      <FormGroup label="Type Full Legal Name">
        <input
          className="form-input"
          value={name}
          onChange={(e) => onNameChange && onNameChange(e.target.value)}
        />
      </FormGroup>
      <FormGroup label="Today's Date">
        <DatePicker
          className="form-datepicker"
          style={{ width: "100%" }}
          value={date ? dayjs(date) : null}
          onChange={(d) => onDateChange && onDateChange(d ? d.format("YYYY-MM-DD") : "")}
          format="MM/DD/YYYY"
        />
      </FormGroup>
    </FormGrid>
  </div>
);

export default SignatureSection;
